export default {
  namespaced: true,

  state: {
    companiesList: [],
    companiesData: {},
    editItem: null,
    isLoading: false,
    error: null
  },
  getters: {
    companiesList(state) {
      return state.companiesList
    },
    companiesData(state) {
      return state.companiesData
    },
    editItem(state) {
      // console.log(state.editItem)
      return state.editItem
    },
    isLoading(state) {
      return state.isLoading
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_COMPANIES(state, companiesList) {
      console.log(companiesList)
      state.companiesList = companiesList 
    },
    SET_COMPANY_DATA(state, companiesData) {
      state.companiesData = companiesData
    },
    GET_COMPANY(state, index) {
      let editItemIndex = state.companiesList.map(function(item) { return item.id; }).indexOf(parseInt(index));
      state.editItem = state.companiesList[editItemIndex]
    },
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    REMOVE_ROW(state, index) {
      let removeIndex = state.companiesList.map(function(item) { return item.id; }).indexOf(index);
      state.companiesList.splice(removeIndex, 1);
    },
  },
  actions: {
    deleteRow({commit}, dispatch_data) {
      commit('REMOVE_ROW', dispatch_data.id)
    },
  }
}
